module.exports = __webpack_public_path__ + "static/media/prajakta.8d640197.png";